import { Button, CardActions, Grid } from '@material-ui/core'
import i18n from 'i18next'
import { Navigate } from '../../../actions/types'
import {
  trackApratmentView,
  trackApplicantView
} from '../../../services/segment'
import { MuiClasses } from '../../../types'
import { ApartmentStatus, Apartment } from '../../../types/apartments'
import { getStepPath } from '../../../utils/steps'

interface ApartmentCardButtonsProps {
  apartment: Apartment
  navigate: Navigate
  hasApplications: boolean
  t: i18n.TFunction
  classes: MuiClasses
}
const ApartmentCardButtons = ({
  apartment,
  classes,
  navigate,
  hasApplications,
  t
}: ApartmentCardButtonsProps) => {
  const { apartmentId, userId, status } = apartment
  return (
    <CardActions className={classes.cardActions}>
      <Grid container justify='space-between' alignItems='baseline' spacing={1}>
        <Grid item xs={6}>
          {status === ApartmentStatus.created && (
            <Button
              size='small'
              variant='contained'
              color='primary'
              className={classes.primaryBtn}
              fullWidth
              onClick={() => navigate(getStepPath(apartment))}
            >
              {t('apartments.card.editApartment')}
            </Button>
          )}
          {status !== ApartmentStatus.created && (
            <Button
              size='small'
              variant='contained'
              color='primary'
              className={classes.primaryBtn}
              fullWidth
              onClick={() => {
                trackApratmentView(apartmentId)
                navigate(`/users/${userId}/apartments/${apartmentId}/overview`)
              }}
            >
              {t('apartments.card.overviewApartment')}
            </Button>
          )}
        </Grid>
        <Grid item xs={6}>
          <Button
            size='small'
            variant='outlined'
            color='primary'
            fullWidth
            className={classes.primaryBtnOutlined}
            onClick={() => {
              trackApplicantView(userId, apartmentId)
              navigate(
                `/users/${userId}/apartments/${apartmentId}/applications`
              )
            }}
          >
            {t('apartments.card.applications')}
          </Button>
        </Grid>
      </Grid>
    </CardActions>
  )
}

export default ApartmentCardButtons
